import { z } from 'zod';

export const investmentDetailsGetResponseSchema = z.object({
  data: z.object({
    company: z
      .object({
        current_share_class: z.string().optional(),
        expected_profit: z.string().optional(),
        investment_history: z
          .array(
            z.object({
              closing_balance: z.number(),
              closing_shares: z.number(),
              date: z.string(),
              dividend_payments: z.number(),
              investment_amount: z.number(),
              opening_balance: z.number(),
              price_per_share: z.number(),
              share_class: z.string(),
              share_purchases: z.number(),
              updated_at: z.string(),
            })
          )
          .optional(),
        monthly_investment_amount: z.string().optional(),
        monthly_investment_amount_remaining: z.string().optional(),
        portfolio_value: z.string().optional(),
        portfolio_value_progress_percentage: z.number().optional(),
        price_per_share_history: z.array(z.object({ date: z.string(), price_per_share: z.number() })).optional(),
        share_class_progress_percentage: z.number().optional(),
        show_gain_loss: z.boolean().optional(),
        show_top_up_account: z.boolean().optional(),
        subscription_form_link: z.string().optional(),
        title: z.string(),
        total_gain_loss_amount: z.string().optional(),
        total_gain_loss_percentage: z.number().optional(),
        total_gain_loss_progress_percentage: z.number().optional(),
        total_investment: z.string(),
      })
      .optional(),
  }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
